import React, { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { Flex, Tag } from '@chakra-ui/react'

//UI

import PM040Selection from '@/features/offers/offer-detail/tabs/OfferSourcingTab/CostBudget/PM040Selection'
import PM100Selection from '@/features/offers/offer-detail/tabs/OfferSourcingTab/CostBudget/PM100Selection'

//State

//Helper

import { CostBudgetAccessProvider, useCostBudgetAccess } from './CostBudgetAccessProvider'
import CostBudgetGeneralInfo from './CostBudgetGeneralInfo'
import CostBudgetInternalDocumentSection from './CostBudgetInternalDocumentSection'
import CostBudgetTenderDocumentSection from './CostBudgetTenderDocumentSection/CostBudgetTenderDocumentSection'
import CostBudgetVendorSection from './CostBudgetVendorSection'

const CostBudgetContent = ({ costBudgetIndex }) => {
  const { getValues } = useFormContext()
  const { showPM040, showPM100 } = useCostBudgetAccess()

  const splitForm = useWatch({ name: `sourcing.costBudgets.${costBudgetIndex}.splitForm` }) ?? ''

  const originalCostBudget = useMemo(() => {
    const costBudgets = getValues(`sourcing.costBudgets`)
    if (splitForm === '') return null

    return costBudgets.find((cb) => cb?.detail?._id === splitForm)
  }, [splitForm, getValues])

  return (
    <Flex direction={'column'} gap="5" maxW="100%" width="100%">
      <Flex bg="green" width="3000px"></Flex>
      {originalCostBudget?.detail?.purpose && originalCostBudget?.detail?.purpose !== '' && (
        <Flex>
          <Tag colorScheme="yellow">Split Form {originalCostBudget?.detail?.purpose}</Tag>
        </Flex>
      )}
      <CostBudgetGeneralInfo costBudgetIndex={costBudgetIndex} />
      <CostBudgetVendorSection costBudgetIndex={costBudgetIndex} />
      <CostBudgetTenderDocumentSection costBudgetIndex={costBudgetIndex} />
      <CostBudgetInternalDocumentSection costBudgetIndex={costBudgetIndex} />
      {showPM040 && <PM040Selection costBudgetIndex={costBudgetIndex} />}
      {showPM100 && <PM100Selection costBudgetIndex={costBudgetIndex} />}
    </Flex>
  )
}

const CostBudget = ({ costBudgetIndex, hasSelectedSubSystem = false }) => {
  return (
    <CostBudgetAccessProvider costBudgetIndex={costBudgetIndex} hasSelectedSubSystem={hasSelectedSubSystem}>
      <CostBudgetContent costBudgetIndex={costBudgetIndex} />
    </CostBudgetAccessProvider>
  )
}

export default CostBudget
